import request from '@/router/axios'; // 获取项目档案fenye列表

export function projectPage(query) {
  return request({
    url: '/api/project/page',
    method: 'get',
    params: query
  });
}
export function projectList(query) {
  return request({
    url: '/api/project/list',
    method: 'get',
    params: query
  });
} // 添加项目档案

export function addproject(obj) {
  return request({
    url: '/api/project',
    method: 'post',
    data: obj
  });
} // 修改xiangmudangan

export function putproject(obj) {
  return request({
    url: '/api/project',
    method: 'put',
    data: obj
  });
} //删除设备

export function deleteproject(obj) {
  return request({
    url: '/api/project',
    method: 'delete',
    params: obj
  });
} // 修改设备

export function putdevice(obj) {
  return request({
    url: '/api/device',
    method: 'put',
    data: obj
  });
} // 解绑设备（删除设备）

export function unbindDevice(obj) {
  return request({
    url: '/api/project/unbindDevice',
    method: 'post',
    params: obj
  });
} //档案详情

export function projectDeviceList(query) {
  return request({
    url: '/api/project/getDeviceListById',
    method: 'get',
    params: query
  });
} //设备型号统计

export function projectgetDeviceModelById(query) {
  return request({
    url: '/api/project/getDeviceModelById',
    method: 'get',
    params: query
  });
} // 获取电梯 和设备型号

export function dictList(query) {
  return request({
    url: '/api/blade-system/dict-biz/list',
    method: 'get',
    params: query
  });
} // 绑定通信板

export function bindingImei(query) {
  return request({
    url: '/api/project/bindingImei',
    method: 'post',
    data: query
  });
} // 人员列表

export function user_list(query) {
  return request({
    url: "/api/blade-user/user-list",
    method: 'GET',
    params: query
  });
} // 项目名称历史

export function getProjectNameListById(query) {
  return request({
    url: "/api/project/getProjectNameListById",
    method: 'GET',
    params: query
  });
} // 切换项目状态

export function updateStatus(query) {
  return request({
    url: "/api/project/updateStatus",
    method: 'put',
    data: query
  });
} // 下载通信板模板

export function exportTemplate(query) {
  return request({
    url: "/api/device/export-template",
    method: 'GET',
    params: query,
    responseType: 'blob'
  });
} // 导入通信版

export function importDevice(query) {
  // const formData = new FormData();
  // formData.append('projectId', query.projectId);
  // formData.append('isCovered', query.isCovered);
  // formData.append('file', query.file);
  return request({
    url: "/api/device/import-device",
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: query
  });
} // 根据空调编号 获取 空调型号

export function getDeviceModel(query) {
  return request({
    url: "/api/blade-system/dict-biz/getDeviceModel",
    method: 'GET',
    params: query
  });
}